import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './Hero.module.css';
import smoothScroll from '../../utils/smoothScroll';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const Hero = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const handleRequestDemoClick = (e) => {
        e.preventDefault();
        const targetId = 'cta-form';
        const interestQueryValue = 'software_platform';

        if (window.dataLayer) {
            window.dataLayer.push({
                event: 'cta_button_click',
                button_name: 'Request a Demo',
                location: 'hero_section'
            });
        }

        navigate(`/#${targetId}?interest=${interestQueryValue}`, { replace: false });

        setTimeout(() => {
            smoothScroll(null, targetId);
        }, 0);
    };

    return (
        <section id="hero" className={styles.hero}>
            <picture>
                <source srcSet="/images/hero-combine-field-hex-overlay.webp" type="image/webp" />
                <img 
                    src="/images/hero-combine-field-hex-overlay.png" 
                    alt="Green Growth combine in field" 
                    className={styles.heroBgImg}
                    style={{ position: 'absolute', width: '100%', height: '100%', objectFit: 'cover', zIndex: -1, top: 0, left: 0 }}
                />
            </picture>
            <Helmet>
                <title>Green Growth - Precision Yield Monitoring</title>
                <meta name="description" content="Unlock your farm's potential with Green Growth. Precision sensors and intelligent software for cereals and potatoes, turning data into profit." />
                <meta property="og:title" content="Green Growth - Precision Yield Monitoring" />
                <meta property="og:description" content="Unlock your farm's potential with Green Growth. Precision sensors and intelligent software for cereals and potatoes, turning data into profit." />
                <meta property="og:image" content="https://greengrowth.tech/images/og-image.jpg" />
                <link rel="canonical" href="https://greengrowth.tech/" />
                <link rel="alternate" href="https://greengrowth.tech/" hreflang="en" />
                <link rel="alternate" href="https://greengrowth.tech/es/" hreflang="es" />
                <script type="application/ld+json">{`
                  {
                    "@context": "https://schema.org",
                    "@type": "Organization",
                    "name": "Green Growth Innovations Inc.",
                    "url": "https://greengrowth.tech/",
                    "logo": "https://greengrowth.tech/images/green-growth-logo-white.png",
                    "contactPoint": [{
                      "@type": "ContactPoint",
                      "email": "support@greengrowth.tech",
                      "contactType": "customer support",
                      "url": "https://greengrowth.tech/"
                    }],
                    "sameAs": [
                      "https://www.linkedin.com/company/green-growth-innovations/"
                    ]
                  }
                `}</script>
            </Helmet>
            <h1>{t('hero.title')}</h1>
            <p>{t('hero.subtitle')}</p>
            <a 
                href={`/#cta-form?interest=software_platform`} 
                className={`btn btn-primary ${styles.heroBtnPrimary}`} 
                onClick={handleRequestDemoClick}
            >
                {t('hero.ctaButton')}
            </a>
        </section>
    );
};

export default Hero;
